<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="24" class='flex'>
        <el-select v-if="theUserProject == 0" v-model='theProjectId' @change="theProjectAllChange" size="small" clearable
          placeholder="请选择项目">
          <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId" :label="item.projectName"
            :value="item.projectId">
          </el-option>
        </el-select>
        <!-- <el-cascader v-if="theUserProject != 0" ref='cascader' v-model="getUserVisitorList_data.dtId" clearable filterable
          size='small' placeholder='请选择战队' :show-all-levels='false'
          :options="getDepartmentAllList_data ? getDepartmentAllList_data.data : []"
          :props="{ expandTrigger: 'hover', checkStrictly: true, emitPath: false, label: 'dtName', value: 'dtId', children: 'children' }"
          @change="theDtChange">
          <template slot-scope="{ data }">
            <span onclick="this.parentNode.previousElementSibling.click()">{{ data.dtName }}</span>
          </template>
        </el-cascader> -->
        <el-select v-model="userId" @change="theDtChange" size="small" filterable clearable placeholder="请选择学员">
          <el-option v-for="item in getProjectUserAll_data.data || []" :key="item.userId" :label="item.userName"
            :value="item.userId">
          </el-option>
        </el-select>
        <el-date-picker v-model="valueDate" size='small' type="datetimerange" :picker-options="pickerOptions"
          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="timeChange"
          value-format="yyyy-MM-dd HH:mm:ss" align="right">
        </el-date-picker>
        <el-button @click="getData()" type="primary" icon='el-icon-search' size='small' style='margin-left:10px;'>搜索
        </el-button>
        <el-button @click="Out()" type="primary" size='small' style='margin-left:10px;'>导出
        </el-button>
        <!-- <el-button @click="toExport" type="primary" icon='el-icon-search' size='small' style='margin-left:10px;'>导出带图片
        </el-button>
        <el-button @click="toExportNoImage" type="primary" icon='el-icon-search' size='small' style='margin-left:10px;'>
          导出不带图片
        </el-button> -->
      </el-col>
    </el-row>

    <myform :viewobj='{
      updateUserVisitorAttr: ["修改打卡信息", "el-icon-edit-outline"],
      $succeed$: getUserVisitorList
    }' @close='$form("updateUserVisitorAttr", "reset")'>
      <template v-slot:customId="{ Myformdata }">
       
      </template>

    </myform>
    <mytable ref="getUserVisitorListTable" :tableColums='tableColums_getUserVisitorList' api='getUserVisitorList::uvId'
      :height="H - 165">
      <div slot="uvImgListString" slot-scope="{row}" style="max-height:30vh;overflow:auto;max-width:99%;" class="fCenter">
        <img :src="img" alt="" loading="lazy" v-for="img in
              typeof row.uvImgListString == 'string'
                ? (row.uvImgListString = window.JSON.parse(row.uvImgListString))
                : row.uvImgListString" onclick="document.PreviewVideo(this.src)" :title="'点击预览 ' + img" :key="img" />
      </div>
    </mytable>
    <el-dialog title="导出-是否带出图片" :visible.sync="isBulk" width="30%" :before-close="BulkClose" style="margin-left: 160px;">

      <el-radio-group v-model="imgType" style="display:block;text-align: center;">
        <el-radio-button :label="2">是</el-radio-button>
        <el-radio-button :label="1">否</el-radio-button>

      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="BulkClose">取 消</el-button>
        <el-button type="primary" @click="Bulksure">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="拜访详情" :visible.sync="kehuDetail" width="70%" :before-close="kehuDetailClose"
      style="margin-left: 200px;">

      <!-- 自定义打卡 -->
      <div v-if="Detailtype == 1">
        <el-descriptions :column="1" border :labelStyle="{
          color: '#409EFF',
          textAlign: 'center',
          width: '20%',
          fontSize: '12px'
        }" :contentStyle="{ textAlign: 'left', width: '80%', fontSize: '12px' }">
          <el-descriptions-item
            :contentStyle="{ textAlign: 'center', fontSize: '12px', display: 'flex', justifyContent: 'space-around' }"
            label="客户名称">
            {{ detailArr2.customName }}
          </el-descriptions-item>
          <el-descriptions-item
            :contentStyle="{ textAlign: 'center', fontSize: '12px', display: 'flex', justifyContent: 'space-around' }"
            label="地理位置">
            {{ detailArr2.uvLocation }}
          </el-descriptions-item>
          <el-descriptions-item
            :contentStyle="{ textAlign: 'center', fontSize: '12px', display: 'flex', justifyContent: 'space-around' }"
            label="走访时间">
            {{ detailArr2.uvTime }}
          </el-descriptions-item>
        </el-descriptions>
        <el-table ref="kehuTable" :data="kehuData" stripe border style="width: 100%" max-height="500px"
          :cell-style="{ textAlign: 'center' }" :header-cell-style="{
            textAlign: 'center',
            background: 'rgba(0,170,255,0.5)',
            color: 'black',
            border: 'none'
          }">
          <el-table-column prop="qtName" label="题目名称" fixed="left">
          </el-table-column>
          <el-table-column prop="qttName" label="题目类型">
          </el-table-column>
          <el-table-column prop="qtOrder" label="排序" fixed="left">
          </el-table-column>
          <el-table-column prop="qtiValue" label="所选答案">
            <template slot-scope="scope">
              <img class="el-upload-list__item-thumbnail" :src="scope.row.qtiValue" alt=""
                style="width: 50px;height: 50px;" @click="PreviewVideo(scope.row.qtiValue)"
                v-if="scope.row.qttId == 3 && scope.row.qtiValue != '跳过'">
              <span v-if="scope.row.qttId == 3 && scope.row.qtiValue == '跳过'">{{ scope.row.qtiValue }}</span>
              <span v-if="scope.row.qttId != 3">{{ scope.row.qtiValue }}</span>
            </template>
          </el-table-column>

        </el-table>
      </div>

    </el-dialog>

  </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
export default {
  data() {
    return {
      BUildingFold: false,
      formDetail: {},
      formBuilding: {},
      DiyList: [],
      userId: '',
      imgType: 1,
      isBulk: false,
      command: null,
      userName: '',
      companyFold: false,
      PropertyFold: false,
      BuildingArr: [],
      CompanyArr: [],
      PrepertyArr: [],
      Detailtype: 0,
      detailArr2: [],
      detailObj: [],
      kehuDetail: false,
      kehuData: [],
      vId: null,
      theProjectId: "",
      theUserProject: "",
      thepvcId: "",
      theDtId: "",
      theBusinessType: "",
      tableColums_getUserVisitorList: {
        $selection: true,

        userName: '拜访员工',

        dtName: '分公司',

        customName: '客户名称',

        uvTime: '走访时间',

        uvLocation: '位置',

        uvImgListString: '打卡图片',

        createtime: '创建时间',
       

        $operation: [
          '操作', 200,
          this.deleteUserVisitor && `@text: 删除#danger
           @click: _confirm('确定要删除该拜访记录吗，此操作不可逆?')
                   .trigger('deleteUserVisitor',{uvId:$row.uvId})
                   .trigger('getUserVisitorList')
          `,
          `@text: 详情#success
           
            @click:VisitDetail($row)
          `,
        ],

      },
      baseUrl: $Api.baseUrl_online,
      valueDate: "",
      startDate: "",
      endDate: "",
      loading: null,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

    };
  },

  watch: {

  },

  methods: {
    PreviewVideo(url){
      document.PreviewVideo(url)
    },
    theDtChange(e) {
      this.userId = e
      this.getData();
    },
    Bulksure() {
        const selection = Object.keys(this.$refs.getUserVisitorListTable.$MyTableCache);
        const bulkdata = {
          projectId: this.theProjectId,
          currentPage: 1,
          btId: this.theBusinessType || null,
          pvcId: this.thepvcId || null,
          dtId: this.theDtId || null,
          uvStartTime: this.startDate || null,
          uvEndTime: this.endDate || null,
          userName: this.userName || null,
          userId: this.userId || null,
          exportType: 2,
          hasImage: this.imgType,
          uvIds: selection.join()
        }
        this.openLoading();
        var s = qs.stringify(bulkdata);
        var that = this
        axios({
          method: 'post',
          url: that.baseUrl + '/opportunity/user-visitor/exportUserVisitor',
          data: s,
          withCredentials: true,
          timeout: 1200000,
          responseType: 'arraybuffer',
          headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            'token': A.local('$Usertoken'),
            'projectId': +A.local('$projectId'),
          }
        }).then(function (res) {
          if (res.data) {
            that.loading.close();
            let a = document.createElement('a');
            //ArrayBuffer 转为 Blob
            let blob = new Blob([res.data], {
              type: "application/vnd.ms-excel"
            });
            let objectUrl = URL.createObjectURL(blob);
            a.setAttribute("href", objectUrl);
            a.setAttribute("download", '打卡.xlsx');
            a.click();
            that.$message({
              message: "成功",
              type: "success"
            });
            that.BulkClose()
          }
        })
    },
    BulkClose() {
      this.isBulk = false;

    },
    Out(e) {
        this.isBulk = true;
    },
    getList(e) {
      this.userName = e
    },
    kehuDetailClose() {
      this.kehuDetail = false;
    },
    VisitEdit(row) {
      this.getUserVisitorOtherOne({ uvId: row.uvId }).result(res => {
        // this.detailArr2 = res.data.data;
        this.$form("updateUserVisitorAttr", res.data.data);
        this.Myformdata.customId = res.data.data.customId * 1;
        this.Myformdata.yuvbId = res.data.data.userVisitorBuilding.yuvbId;
        this.Myformdata.yuvbcId = res.data.data.userVisitorBuilding.yuvbcId * 1
        this.Myformdata.yuvpId = res.data.data.userVisitorProperty.yuvpId * 1;

      })
    },
    VisitDetail(row) {
      console.log(row)

      this.getUserVisitorOtherOne({ uvId: row.uvId }).result(res => {

        if (res.data.data.uvcId == 2) {
          console.log('2');
          this.Detailtype = 2
          this.detailArr2 = res.data.data;
          this.BuildingArr = res.data.data.userVisitorBuilding;
          this.CompanyArr = {

          };
          this.PrepertyArr = res.data.data.userVisitorProperty;
          this.kehuDetail = true;
          return
        }
        if (res.data.data.uvcId == 1) {
          console.log('2');
          this.Detailtype = 2
          this.detailArr2 = res.data.data;
          this.BuildingArr = res.data.data.userVisitorBuilding;
          this.CompanyArr = {

          };
          this.PrepertyArr = res.data.data.userVisitorProperty;
          this.kehuDetail = true;
          return
        }
        if (res.data.data.uvcId == 3) {
          console.log('2');
          this.Detailtype = 3
          this.detailArr2 = res.data.data;
          this.BuildingArr = res.data.data.userVisitorBuilding;
          this.CompanyArr = {

          };
          this.PrepertyArr = res.data.data.userVisitorProperty;
          this.kehuDetail = true;
          return
        }
        this.Detailtype = 1
        res.data.data.userVisitorAttrList.forEach((item, ind) => {
          if (item.qttId == 3 && item.qtiValue != '跳过') {
            item.qtiValue = item.qtiValue
            console.log(item)
          }
        })
        this.detailArr2 = res.data.data;
        this.kehuData = res.data.data.userVisitorAttrList;
        this.kehuDetail = true;
      })
    },
    openLoading() {
      //loading请求等待
      this.loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    timeChange(e) {
      if (e) {
        this.startDate = e[0];
        this.endDate = e[1];
      } else {
        this.startDate = "";
        this.endDate = "";
      }

    },
    toExport: async function () {
      const that = this;
      var postData = {
        btId: that.theBusinessType,
        pvcId: that.thepvcId,
        dtId: that.theDtId,
        projectId: that.theProjectId,
        uvStartTime: that.startDate,
        userId: that.userId || null,
        uvEndTime: that.endDate
      };
      var s = qs.stringify(postData);
      that.openLoading();
      axios({
        method: 'post',
        url: that.baseUrl + '/opportunity/user-visitor/exportUserVisitor',
        data: s,
        withCredentials: true,
        timeout: 1200000,
        responseType: 'arraybuffer',
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          'token': A.local('$Usertoken'),
          'projectId': +A.local('$projectId'),
        }
      }).then(function (response) {
        that.loading.close();
        let a = document.createElement('a');
        //ArrayBuffer 转为 Blob
        let blob = new Blob([response.data], {
          type: "application/vnd.ms-excel"
        });
        let objectUrl = URL.createObjectURL(blob);
        a.setAttribute("href", objectUrl);
        a.setAttribute("download", '打卡.xlsx');
        a.click();
        that.$message({
          message: "成功",
          type: "success"
        });
      }).catch(function (error) {
        that.loading.close();
        console.log(error);
      });
    },
    toExportNoImage: async function () {
      const that = this;
      var postData = {
        btId: that.theBusinessType,
        pvcId: that.thepvcId,
        dtId: that.theDtId,
        projectId: that.theProjectId,
        uvStartTime: that.startDate,
        userId: that.userId || null,
        uvEndTime: that.endDate
      };
      var s = qs.stringify(postData);
      that.openLoading();
      axios({
        method: 'post',
        url: that.baseUrl + '/opportunity/user-visitor/exportUserVisitorNoImage',
        data: s,
        withCredentials: true,
        timeout: 1200000,
        responseType: 'arraybuffer',
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          'token': A.local('$Usertoken'),
          'projectId': +A.local('$projectId'),
        }
      }).then(function (response) {
        that.loading.close();
        let a = document.createElement('a');
        //ArrayBuffer 转为 Blob
        let blob = new Blob([response.data], {
          type: "application/vnd.ms-excel"
        });
        let objectUrl = URL.createObjectURL(blob);
        a.setAttribute("href", objectUrl);
        a.setAttribute("download", '打卡.xlsx');
        a.click();
        that.$message({
          message: "成功",
          type: "success"
        });
      }).catch(function (error) {
        that.loading.close();
        console.log(error);
      });
    },
    vtChange(e) {
      this.thepvcId = e;
      this.getUserVisitorList({
        currentPage: 1,
        btId: this.theBusinessType,
        pvcId: this.thepvcId,
        dtId: this.theDtId,
        userId: this.userId || null,
        uvStartTime: this.startDate,
        uvEndTime: this.endDate,
        userName: this.userName || null,
      });
    },
    theBusinessTypeChange(e) {
      this.theBusinessType = e;
      this.getUserVisitorList({
        currentPage: 1,
        btId: this.theBusinessType,
        pvcId: this.thepvcId,
        dtId: this.theDtId,
        uvStartTime: this.startDate,
        uvEndTime: this.endDate,
        userId: this.userId || null,
        userName: this.userName || null,
      });
    },
    theDtChange(e) {
      this.theDtId = e;
      this.$refs.cascader.dropDownVisible = false;
      this.getUserVisitorList({
        currentPage: 1,
        btId: this.theBusinessType,
        pvcId: this.thepvcId,
        dtId: this.theDtId,
        uvStartTime: this.startDate,
        userId: this.userId || null,
        uvEndTime: this.endDate,
        userName: this.userName || null,
      });
    },
    getData() {
      this.getUserVisitorList({
        projectId: this.theProjectId,
        currentPage: 1,
        btId: this.theBusinessType || null,
        pvcId: this.thepvcId || null,
        dtId: this.theDtId || null,
        userId: this.userId || null,
        uvStartTime: this.startDate || null,
        uvEndTime: this.endDate || null,
        userName: this.userName || null,
      });
    },
    theProjectAllChange(e) {
      this.theProjectId = e;
      this.getData();
    },
  },

  created() {
    this.theUserProject = A.local('$projectId');
    if (this.theUserProject == 0) {
      this.getProjectList({
        pageSize: 0
      });
    } else {
      this.theProjectId = this.theUserProject;
    }
    this.getUserVisitorList({ projectId: A.local('$projectId') });
    this.getProjectUserAll({
      postId: 5,
      projectId: A.local('$projectId'),
    })
   
  },
  mounted() {

  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/help/VisitRecord.vue